/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/*@ngInject*/
export default function ResetPasswordRequestController($translate, toast, loginService) {
    var vm = this;

    vm.$onInit = function () {
        vm.email = '';
        vm.sendResetPasswordLink = sendResetPasswordLink;
    };

    function sendResetPasswordLink() {
        loginService.sendResetPasswordLink(vm.email).then(function success() {
            toast.showSuccess($translate.instant('login.password-link-sent-message'));
        }, function fail() {
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/login/reset-password-request.controller.js